/* eslint-disable @typescript-eslint/naming-convention */
import { InTopic } from './InTopic';
import { AnyInMessageTopic } from './InMessageTopic';
import { SetOrderIdsMessage } from './messages/SetOrderIdsMessage';
import { SetPositionsMessage } from './messages/SetPositionsMessage';
import { AuthenticateMessage } from 'embedded/api/in/messages/AuthenticateMessage';
import { LogoutMessage } from 'embedded/api/in/messages/LogoutMessage';
import { SetPortfolioMessage } from 'embedded/api/in/messages/SetPortfolioMessage';

export function bootstrapInTopics(): Record<InTopic, AnyInMessageTopic> {
    return {
        SET_ORDER_IDS: new SetOrderIdsMessage(),
        SET_POSITIONS: new SetPositionsMessage(),
        SET_PORTFOLIO: new SetPortfolioMessage(),
        AUTHENTICATE: new AuthenticateMessage(),
        LOGOUT: new LogoutMessage(),
    };
}
